import SourceCard from '@components/SourceCard/SourceCard';
import { FormattedMessage } from 'react-intl';
import type { NewsArticle } from 'src/types/sentinel';

import './SourceAccordion.css';

export default function SourceAccordion({ allSources }: { allSources: NewsArticle[] }) {
	return (
		<details className="sources-accordion">
			<summary>
				<span>
					<FormattedMessage id="sentinel.view-sources" />
				</span>
				<span className="icon icon-angle-down" />
			</summary>
			<ul className="sources-list">
				{allSources.map((source, idx) => (
					<SourceCard key={`${source.url || idx}-${idx}`} source={source} />
				))}
			</ul>
		</details>
	);
}
